require('../../modules/es.number.is-integer');
var path = require('../../internals/path');

module.exports = path.Number.isInteger;



//////////////////
// WEBPACK FOOTER
// ./~/core-js/es/number/is-integer.js
// module id = 1218
// module chunks = 1